export const EVENTS_NAMES = {
  USER_VISIT: "User visited landing page",
};
